import { useEffect, useState } from "react";

/** Stable object URL for a `File`, revoked when the file changes or the hook unmounts. */
export function useObjectUrl(file: File | null | undefined): string | undefined {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!file) {
      setUrl(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
}
